/**
 * Style Station API functions.
 *
 * Generates AI outfit visualisations from text descriptions via the
 * /style-station backend endpoints (Feature Code: HOKU009).
 */
import { apiFetch, buildUrl, PROXY_BASE, AI_TIMEOUT } from "@/shared/api/client";
import type { ApiResponse } from "@/shared/api/types";
import type {
  StyleGeneration,
  StyleStationListParams,
  StyleStationListResponse,
  StyleStationRequest,
} from "@/types/api";

/**
 * Get style generation history (paginated)
 */
export async function getStyleHistory(
  params: StyleStationListParams
): Promise<ApiResponse<StyleStationListResponse>> {
  return apiFetch(
    buildUrl(
      `${PROXY_BASE}/style-station`,
      params as unknown as Record<string, unknown>
    )
  );
}

/**
 * Generate AI outfit visualisation from text description.
 * Cost: 5 Hoku Coins (Feature Code: HOKU009)
 */
export async function generateStyle(
  request: StyleStationRequest
): Promise<ApiResponse<StyleGeneration>> {
  return apiFetch(`${PROXY_BASE}/style-station`, {
    method: "POST",
    body: JSON.stringify(request),
    timeout: AI_TIMEOUT,
  });
}

/**
 * Get specific style by ID
 */
export async function getStyle(
  id: string
): Promise<ApiResponse<StyleGeneration>> {
  return apiFetch(`${PROXY_BASE}/style-station/${id}`);
}

/**
 * Delete a style generation
 */
export async function deleteStyle(
  id: string
): Promise<ApiResponse<{ deleted: boolean }>> {
  return apiFetch(`${PROXY_BASE}/style-station/${id}`, {
    method: "DELETE",
  });
}

/**
 * Toggle style like status
 */
export async function toggleStyleLike(
  id: string,
  userId: string
): Promise<ApiResponse<{ liked: boolean }>> {
  return apiFetch(`${PROXY_BASE}/style-station/${id}/like`, {
    method: "POST",
    body: JSON.stringify({ userId }),
  });
}
